export const SET_CONNECTOR = 'SET_CONNECTOR';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_CHAIN_ID = 'SET_CHAIN_ID';
